
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/addPreset/htmlPreviewThumbnail/htmlThumbnailDragBox.scss.css.virtualfile';
        module.exports = {"htmlThumbnailDragBox":"_htmlThumbnailDragBox_pf8vv_7"};